export class JsonResponse {
  message: any;
  status: string;
  constructor(values: any = {}) {
    Object.assign(this, values);
  }
}
